module.exports = __webpack_public_path__ + "static/media/stm-21st-tablet-1476x114-@2x.ac7c65b9.webp";